<div>
    <!--    <div class="dnd-handler">-->
    <!--        <span class="sp-icon icon-drag-drop"> </span>-->
    <!--    </div>-->

    <div class="drawer-item-wrap">
        <div [id]="'nav-' + entity().id" class="drawer-item" [class.active]="isActive()" (click)="selectEntity()">
            <div class="drawer-item-content">
                <small
                    class="sp-icon icon-chevron-right"
                    style="display: block"
                    [style.rotate]="showChildren() ? '90deg' : '0deg'"
                >
                </small>

                <img src="./assets/img/websites/lpc-column-icon.svg" alt="lpc-column-icon" />

                <div class="text-wrapper">
                    <div class="text-item">{{ columnName() | translate }}</div>
                    <div class="id-item" [title]="'id: ' + displayId()">id: {{ displayId() }}</div>
                </div>
            </div>
        </div>
        @if (!isSpecific()) {
            <div dropdown #dropdown="bs-dropdown" class="btn-group dropdown dropdown-options">
                <button
                    dropdownToggle
                    type="button"
                    class="btn btn-action dropdown-toggle"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <span class="sp-icon icon-ellipsis"></span>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
                    <li role="menuitem">
                        <a
                            class="dropdown-item"
                            (click)="copyColumn()"
                            [class.disabled]="isCopyDisabled() || isColumnRestricted()"
                        >
                            <span class="sp-icon icon-copy"> </span>
                            {{ "duplicate" | translate }}
                        </a>
                    </li>
                    <li>
                        <hr />
                    </li>
                    <li
                        role="menuitem"
                        [class.disabled]="isDeleteDisabled() || isColumnRestricted()"
                        (click)="removeColumn()"
                    >
                        <a>
                            <span class="sp-icon icon-bin color-danger"></span>
                            {{ "delete" | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        }
    </div>
</div>

@if (showChildren()) {
    <div class="drawer-item-children">
        @for (widget of widgets(); track $index; let i = $index) {
            @if (isTab(widget)) {
                <web-navigation-tab-item [entity]="widget" [index]="i" [selectedEntity]="selectedEntity()" />
            } @else if (isGrid(widget)) {
                <web-navigation-grid-item [entity]="widget" [index]="i" [selectedEntity]="selectedEntity()" />
            } @else {
                <web-navigation-widget-item [entity]="widget" [index]="i" [selectedEntity]="selectedEntity()" />
            }
        }
    </div>
}
